import React from 'react';
import ReactDOM from 'react-dom/client';
import RooCADApp from './App';
import './index.css';

class RootBoundary extends React.Component {
    constructor(props) { super(props); this.state = { error: null }; }
    static getDerivedStateFromError(error) { return { error }; }
    componentDidCatch(error, info) {
        console.error('[RooCAD Root]', error, info);
        window.__roocad_showError?.((error && error.message) || String(error));
    }
    render() {
        if (this.state.error) {
            return (
                <div style={{ height: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', background: '#0f172a', color: '#e2e8f0', fontFamily: 'monospace', padding: 24, textAlign: 'center' }}>
                    <h1 style={{ fontSize: 18, fontWeight: 700, color: '#f87171' }}>RooCAD failed to start</h1>
                    <pre style={{ marginTop: 12, fontSize: 12, color: '#fca5a5', maxWidth: 640, whiteSpace: 'pre-wrap' }}>{String(this.state.error?.message || this.state.error)}</pre>
                    <button onClick={() => { this.setState({ error: null }); }} style={{ marginTop: 20, padding: '10px 22px', background: '#2563eb', color: '#fff', border: 'none', borderRadius: 10, cursor: 'pointer', fontWeight: 700 }}>Retry</button>
                    <button onClick={() => { localStorage.clear(); sessionStorage.clear(); location.reload(); }} style={{ marginTop: 10, padding: '8px 18px', background: '#1e293b', color: '#94a3b8', border: '1px solid #334155', borderRadius: 10, cursor: 'pointer', fontSize: 12 }}>Reset saved data & reload</button>
                </div>
            );
        }
        return this.props.children;
    }
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <RootBoundary>
      <RooCADApp />
    </RootBoundary>
  </React.StrictMode>
);
